import React from "react";
import { connect } from "react-redux";
import { removeInfoFeedMessage } from "../../store/actions";
import BasicButton from "../theme/buttons/BasicButton";

class InfoTileFeed extends React.Component {
  constructor(props) {
    super(props);

    this.timeoutMap = {};
  }

  componentWillUnmount() {
    for (let key in this.timeoutMap) {
      clearTimeout(this.timeoutMap[key].timeoutId);
    }
  }

  dismissMsg = (id) => {
    this.props.removeMessage(id);
  };

  manageTimeout(message, remove = false) {
    if (this.timeoutMap[message.id]) {
      clearTimeout(this.timeoutMap[message.id].timeoutId);
      this.timeoutMap[message.id].timeoutId = 0;

      if (remove) {
        return;
      }

      let timeoutId = setTimeout(
        () => this.dismissMsg(message.id),
        message.timeoutLength
      );
      this.timeoutMap[message.id].timeoutId = timeoutId;
    } else {
      // initialize new message
      let timeoutId = setTimeout(
        () => this.dismissMsg(message.id),
        message.timeoutLength
      );
      this.timeoutMap[message.id] = {};
      this.timeoutMap[message.id].timeoutId = timeoutId;
    }
  }

  renderMessages = () => {
    return this.props.messages.map((m) => {
      this.manageTimeout(m);

      return (
        <div
          key={m.id}
          id={m.id}
          className="wox-card info-tile"
          style={this.props.messageStyle}
          title={this.props.msg}
          data-component="InfoTileFeed"
        >
          <div style={{ display: "flex" }}>
            <span
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                lineHeight: "normal",
                width: "100%",
                zIndex: "9999",
              }}
            >
              {m.msg}
            </span>
            {!m.cantClose && (
              <i
                className="fa fa-times"
                onClick={() => this.dismissMsg(m.id)}
                // style={{ paddingRight: '.5em' }}
              />
            )}
          </div>
          {m.onClick && (
            <BasicButton
              on_click={m.onClick}
              aria_label={m.onClickName}
              label={m.onClickName}
              className="info-tile-action"
            />
          )}
        </div>
      );
    });
  };

  render() {
    if (this.props.showInfoFeed) {
      return (
        <div
          id={"info-feed-wrapper"}
          style={{ ...this.props.infoFeedStyleConfig }}
          data-component="InfoTileFeed"
        >
          {this.renderMessages()}
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  messages: state.infoFeed.data,
});

const mapDispatchToProps = (dispatch) => ({
  removeMessage: (msg) => dispatch(removeInfoFeedMessage(msg)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoTileFeed);
